import { render, staticRenderFns } from "./CompanyList.vue?vue&type=template&id=748b4770&scoped=true"
import script from "./CompanyList.vue?vue&type=script&lang=ts"
export * from "./CompanyList.vue?vue&type=script&lang=ts"
import style0 from "./CompanyList.vue?vue&type=style&index=0&id=748b4770&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "748b4770",
  null
  
)

export default component.exports